<div *ngIf="activeQuestion() as question" [formGroup]="question" class="min-view-time-setting__container" [class.border]="showBorder()">
  <mat-slide-toggle color="primary" labelPosition="before" [checked]="minViewTimeEnabled$()" (change)="onMinViewTimeToggleChange($event.checked)">
    Disable ‘Next’ for a specific duration
  </mat-slide-toggle>

  @if (minViewTimeEnabled$()) {
    <div class="editor-question-form__input">
      <span class="label">Duration (seconds)</span>
      <mat-form-field appearance="outline">
        <input matInput type="number" min="1" formControlName="minViewTimeSeconds" (blur)="onMinViewTimeBlur()" />
      </mat-form-field>
    </div>
  }
</div>
